<template>
<v-data-table v-bind:headers="headers" :items="itemList" item-key="id" :search="search" :mobile-breakpoint="0"
        items-per-page-text="Lignes par page" :items-per-page="15" hide-default-header :loading="loading.fetchData" loading-text="Chargement...">
    <template v-slot:top>
            <v-row class="rounded-lg ma-0 pa-0">
                <v-col cols="6" md="6" class="pa-1">
                <v-text-field append-icon="mdi-magnify" label="Recherche" outlined dense clearable single-line
                            hide-details v-model="search" class="pa-2 rounded-xl">
                </v-text-field>
                </v-col>
            </v-row>
    </template>
    <template v-slot:[`item.tem_name`]="{ item }">
        <v-btn text small color="primary" :to="{ name: 'teams-edit', params: { id: item.tem_id } }">{{ item.tem_name }}</v-btn>
    </template>
    <template v-slot:[`item.tem_usr_id_leader`]="{ item }">
        <v-icon>mdi-account-star</v-icon><span v-if="item.leader">{{ item.leader.lastName }} {{ item.leader.firstName }}</span>
        <span v-else>-</span>
    </template>
    <template v-slot:[`item.tem_sta_id`]="{ item }">
        <v-chip small :color="(item.tem_sta_id == 'GEN01') ? 'success' : 'grey'">{{ stateListById[item.tem_sta_id].sta_label }}</v-chip>
    </template>
    <template v-slot:[`item.actions`]="{ item }">
        <v-icon class="mr-2" @click="$router.push({ name: 'teams-edit', params: { id: item.tem_id } })">mdi-pencil</v-icon>
        <v-icon @click="deleteItem(item)">mdi-delete</v-icon>
    </template>
</v-data-table>
</template>

<script>
import { mapState, mapActions } from 'pinia'
import { useTeamStore } from '@/stores/team'
import { useStateStore } from '@/stores/state'

export default {
    name: 'teams-list',
    computed: {
        ...mapState(useTeamStore, {itemList: 'itemList' }),
        ...mapState(useStateStore, {stateListByGroup: 'itemListByGroup', stateListById: 'itemListById' }),
    },
    data: function () {
        return {
            loading: { fetchData: true },
            search: '',
            pagination: { totalItems: 0, rowsPerPage: 10, rowsPerItem: [15,25,35,{text:'Tout',value:-1}] },
            headers: [
                { text: 'Nom', value: 'tem_name' },
                { text: 'Chef d\'équipe', value: 'tem_usr_id_leader' },
                { text: 'Statut', value: 'tem_sta_id' },
                { text: 'Actions', value: 'actions', sortable: false },
            ],
        }
    },
    async mounted () {
        await this.fetchItems('?extended=withleader')
        this.loading.fetchData = false
    },
    methods: {
        ...mapActions(useTeamStore, ['fetchItems', 'destroyItem']),
        deleteItem(item){
            this.$root.$confirm('Supprimer cette équipe', 'Confirmez vous cette action ?', { color: 'red', width: 400 }).then((confirm) => {
                if( confirm && item.tem_id > 0 ){
                    this.destroyItem(item.tem_id).then( () => {
                        this.fetchItems('?extended=withleader')
                    })
                }
            })
        },
    }
}
</script>
